import { Hammer } from 'lucide-react';
import { Card, EmptyState } from '@proerp/ui';
import { Page, PageHeader } from '@/components/AppShell';

/** Platzhalter für noch nicht gebaute Module — die Navigation bleibt vollständig. */
export function ComingSoonPage({ title }: { title: string }) {
  return (
    <Page>
      <PageHeader title={title} subtitle="Dieses Modul ist noch in Entwicklung." />
      <Card>
        <EmptyState
          icon={Hammer}
          title="In Entwicklung"
          description={`Das Modul „${title}" wird als Nächstes umgesetzt. Aktuell ist das Projekte-Modul vollständig nutzbar.`}
        />
      </Card>
    </Page>
  );
}
